import firebase from 'firebase/app'
import 'firebase/auth'

import { store } from '@/store'

var config = {
  apiKey: 'AIzaSyAXDtStMwLd-1NHsTWy9zIADzG7MRWHEnA',
  authDomain: 'howu-90305.firebaseapp.com',
  databaseURL: 'https://howu-90305.firebaseio.com',
  projectId: 'howu-90305',
  storageBucket: 'howu-90305.appspot.com',
  messagingSenderId: '270178217325'
}

const database = firebase.initializeApp(config)
const google = new firebase.auth.GoogleAuthProvider()
const github = new firebase.auth.GithubAuthProvider()

database.signUp = async (email, password) => {
  try {
    await database.auth().createUserWithEmailAndPassword(email, password)
    store.commit('setCurrentUser', firebase.auth().currentUser)
    return true
  } catch (error) {
    return error
  }
}

database.googleAuth = async () => {
  try {
    await database.auth().signInWithPopup(google)
    store.commit('setCurrentUser', database.auth().currentUser)
    return database.auth().currentUser
  } catch (error) {
    return error
  }
}

database.googleRedirect = async () => {
  await database.auth().signInWithRedirect(google)
}

database.githubAuth = async () => {
  try {
    await database.auth().signInWithPopup(github)
    store.commit('setCurrentUser', database.auth().currentUser)
    return database.auth().currentUser
  } catch (error) {
    return error
  }
}

database.signIn = async (email, password) => {
  try {
    await database.auth().signInWithEmailAndPassword(email, password)
    store.commit('setCurrentUser', database.auth().currentUser)
    return true
  } catch (error) {
    return error
  }
}

database.signOut = async () => {
  try {
    await database.auth().signOut()
    store.commit('setCurrentUser', null)
    return true
  } catch (error) {
    return error
  }
}

export default database



// WEBPACK FOOTER //
// ./src/service/firebase.service.js